import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { workforceHorizontalNavEntryPoint } from '@jira/navigation-apps__horizontal-nav-jsm-workforce/src/workforceHorizontalNavEntryPoint.entrypoint.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { projectSettingsServicedeskWorkforcePermissionsRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskWorkforcePermissionsRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { workforcePermissionsPageEntryPoint } from '@jira/spa-apps__project-settings-service-desk-workforce-permissions/src/workforcePermissionsPageEntryPoint.entrypoint.tsx';
import { WorkforcePermissionsSkeleton } from '@jira/spa-apps__project-settings-service-desk-workforce-permissions/src/WorkforcePermissionsSkeleton.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const projectSettingsServicedeskWorkforcePermissionsPageEntryPoint = createPageEntryPoint({
	main: workforcePermissionsPageEntryPoint,
	horizontalNavigation: workforceHorizontalNavEntryPoint,
});

export const projectSettingsServicedeskWorkforcePermissionsRouteEntry: Route = createEntry(
	projectSettingsServicedeskWorkforcePermissionsRoute,
	() => ({
		group: 'project-settings-servicedesk',
		ufoName: 'jsm-workforce-permissions',
		entryPoint: () =>
			fg('jsm_workforce_permission')
				? projectSettingsServicedeskWorkforcePermissionsPageEntryPoint
				: notFoundPageEntrypoint,
		layout: serviceProjectLayout,
		skeleton: WorkforcePermissionsSkeleton,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		// Project settings shell data only. The workforce routing resources
		// (routingOnboardingFinishedResource, connectTeamsGlobalGroupsResource) stay off this route so
		// the permissions page keeps its own data boundary.
		resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],
		forPaint: [LazyAtlassianNavigation],
		perfMetricKey: 'jsm-workforce-permissions',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
